import React from "react";
import Icon from "Components/UI/Icon/Icon";
import styles from "../styles/ReportsInnerPages.module.scss";
import { StatusFilterOptions } from "Shared/Constants/statusFilter";
import { reminderStatusWithoutIcon } from "Shared/Constants/reports";
import * as echarts from "echarts";

export const useReportsInnerPages = () => {
  const getStatusElement = (
    status: string | null,
    statusFilterOptions: StatusFilterOptions[],
  ) => {
    const foundStatusFrom = statusFilterOptions.find(
      (found: StatusFilterOptions) => found?.value === status,
    );

    return foundStatusFrom ? (
      <div className={styles.statusWrapper}>
        <Icon component={foundStatusFrom.img} />
        <p>{foundStatusFrom.label}</p>
      </div>
    ) : (
      "---"
    );
  };
  const fullNameConvertor = (
    firstName: string | null | undefined,
    lastName: string | null | undefined,
  ) => {
    if (lastName && firstName) {
      return `${lastName} ${firstName}`;
    } else if (lastName) {
      return `${lastName}`;
    } else if (firstName) {
      return `${firstName}`;
    } else {
      return "---";
    }
  };

  const getReminderStatus = (
    statusValue: string,
    vehicleId: string | number,
  ) => {
    const status = reminderStatusWithoutIcon.find(
      (status) => status.value === statusValue,
    );

    if (status) {
      return (
        <span key={vehicleId} style={{ color: status.color }}>
          {status.label}
        </span>
      );
    }

    return null;
  };

  const getGradientColorForChart = (color1: string, color2: string) => {
    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: color1,
      },
      {
        offset: 1,
        color: color2,
      },
    ]);
  };

  return {
    getStatusElement,
    fullNameConvertor,
    getReminderStatus,
    getGradientColorForChart,
  };
};

export default useReportsInnerPages;
